import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import LoginRegister from "./components/LoginRegister/LoginRegister";
import DashboardArea from "./components/DashboardArea/DashboardArea";
import TeamMates from "./components/DashboardArea/TeamMates/TeamMates";

import Listings from "./components/DashboardArea/Listings/Listings";
import AmpPages from "./components/DashboardArea/SettingPages/AmpPages/AmpPages";
import GoogleAnalytics from "./components/DashboardArea/SettingPages/GoogleAnalytics/GoogleAnalytics";
import ExtraCode from "./components/DashboardArea/SettingPages/ExtraCode/ExtraCode";
import MetaTags from "./components/DashboardArea/SettingPages/MetaTags/MetaTags";
import ListingDisplay from "./components/DashboardArea/SettingPages/ListingDisplay/ListingDisplay";
import Search from "./components/DashboardArea/SettingPages/Search/Search";
import Branding from "./components/DashboardArea/SettingPages/Branding/Branding";
import Posts from "./components/DashboardArea/BlogPages/Posts/Posts";
import SingleBlog from "./components/DashboardArea/BlogPages/Posts/SingleBlog";
import ManageTags from "./components/DashboardArea/BlogPages/Posts/ManageTags";
import BlogDefaultSetting from "./components/DashboardArea/BlogPages/Posts/BlogDefaultSetting";
import EmailVerification from "./components/LoginRegister/EmailVerification";
import BrokerLogin from "./components/LoginRegister/BrokerLogin/BrokerLogin";
import RealtorSignUp from "./components/RealtorProcess/RealtorSignup";
import RealtorProfile from "./components/RealtorProcess/RealtorProfile";





function App() {
  return (
      <div className="app-container">
          <BrowserRouter>
             {/*  <Navigation /> */}
             
              <Routes>
                  <Route path="/" index element={<LoginRegister />} /> 
                  <Route path="dashboard" index element={<DashboardArea />} />
                  <Route path="realtor" index element={<TeamMates />} /> 
                  <Route path="listings" index element={<Listings />} /> 
                  <Route path="amp-pages" index element={<AmpPages />} /> 
                  <Route path="google-analytics" index element={<GoogleAnalytics />} /> 
                  <Route path="extra-code" index element={<ExtraCode />} />
                  <Route path="meta-tags" index element={<MetaTags />} />
                  <Route path="listing-display" index element={<ListingDisplay />} />
                  <Route path="search" index element={<Search />} />
                  <Route path="branding" index element={<Branding />} />
                  <Route path="posts" index element={<Posts />} />
                  <Route path="single-blog" index element={<SingleBlog />} />
                  <Route path="manage-tags" index element={<ManageTags />} />
                  <Route path="blog-default-setting" index element={<BlogDefaultSetting />} />

                  <Route path="email-verification" index element={<EmailVerification />} />
                  <Route path="broker-login" index element={<BrokerLogin />} />
                  <Route path="realtor-signup" index element={<RealtorSignUp />} />
                  <Route path="realtor-profile" index element={<RealtorProfile />} />
                
                
              </Routes>
            {/*   <Footer /> */}
          </BrowserRouter>
      </div>
  );
}

export default App;
